import {Injectable} from "@angular/core";



@Injectable({providedIn: 'root'})
export class WatchTokenService {

    prifex: string = 'watch_'

    isTokenExists(publicIdentity){
        return localStorage.getItem(this.prifex+publicIdentity) ? true : false
    }

    setToken(publicIdentity, token){

        localStorage.setItem(this.prifex+publicIdentity, token)
    }


    getToken(publicIdentity){

       return localStorage.getItem(this.prifex+publicIdentity)
    }

    deleteToken(publicIdentity){
        localStorage.removeItem(this.prifex+publicIdentity)
    }

}